import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import JoditEditor from "jodit-react";
import {
  AddAnnoucement,
  GetAllAnnoucement,
  GetCousesOfInstructror,
} from "../../../api";
import ErrorAlert from "../../../commonFunctions/Alerts/ErrorAlert";

// MUI Components
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Container,
  Fade,
  TextField,
  MenuItem,
  Collapse,
  useMediaQuery,
  Grid
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Icons
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import CampaignIcon from "@mui/icons-material/Campaign";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const Annoucements = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // State
  const [isComposeVisible, setComposeVisible] = useState(false);
  const [cmbCourses, setcmbCourses] = useState([]);
  const [selectedCourse, setselectedCourse] = useState("");
  const [announcementTitle, setannouncementTitle] = useState("");
  const [AnnoucementDesc, setAnnoucementDesc] = useState("");
  const [courseCode, setcourseCode] = useState("");
  const [annoucements, setannoucements] = useState([]);

  // --- QUALIGRAD THEME COLORS ---

const colors = {
  primary: "#17082d",
  dark: "#2b2d49",
  light: "#e8e2ed",
  bgGradientStart: "#fafafa",
  bgGradientEnd: "#f3eff6",
  text: "#17082d",
};

  // --- STYLES ---
  const styles = {
    pageWrapper: {
      background: `linear-gradient(135deg, ${colors.bgGradientStart} 0%, ${colors.bgGradientEnd} 100%)`,
      minHeight: "100vh",
      paddingBottom: "2rem",
      marginLeft: isSmallScreen ? "0px" : "260px",
      transition: "margin-left 0.3s ease",
      width: isSmallScreen ? "100%" : "calc(100% - 260px)",
    },
    headerCard: {
      background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.dark} 100%)`,
      color: "white",
      borderRadius: "20px",
      padding: "2rem",
      marginBottom: "2rem",
      boxShadow: "0 10px 40px rgba(0,0,0,0.05)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "1rem"
    },
    composeCard: {
      borderRadius: "16px",
      marginBottom: "2rem",
      border: `1px solid ${colors.light}`,
      boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      overflow: "hidden",
    },
    tableCard: {
      borderRadius: "16px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      overflow: "hidden",
    },
    // Styling for input fields to match Red Theme
    inputField: {
      marginBottom: "1.5rem",
      "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
          borderColor: colors.primary,
        },
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: colors.primary,
      },
    }
  };

  // API Calls
  useEffect(() => {
    GetCousesOfInstructror(setcmbCourses);
    GetAllAnnoucement(courseCode, setannoucements);
  }, [courseCode]);

  // Handlers
  const handleAddAnnouncement = () => {
    if (announcementTitle === "") {
      ErrorAlert("Empty Field", "Please Enter Announcement Title");
      return;
    }
    if (announcementTitle.length > 54) {
      ErrorAlert("Error", "Announcement title should be less than 55 characters");
      return;
    }
    if (selectedCourse === "") {
      ErrorAlert("Error", "Please Select Course");
      return;
    }
    if (AnnoucementDesc === "" || AnnoucementDesc === "<p><br></p>") {
      ErrorAlert("Empty Field", "Please Enter Announcement Description");
      return;
    }

    AddAnnoucement(
      courseCode,
      selectedCourse,
      announcementTitle,
      AnnoucementDesc,
      setComposeVisible,
      setannouncementTitle,
      setAnnoucementDesc,
      setannoucements
    );
  };

  const toggleCompose = () => {
    setComposeVisible(!isComposeVisible);
  };

  const handleSelectAnnoucementFilter = (e) => {
    setcourseCode(e.target.value);
  };

  return (
    <Box style={styles.pageWrapper}>
      <Container maxWidth="xl" sx={{ paddingTop: "2rem" }}>
        
        {/* 1. Header Section */}
        <Fade in timeout={500}>
          <Box style={styles.headerCard}>
            <Box>
              <Typography variant="h4" fontWeight="700" sx={{ display: 'flex', alignItems: 'center', gap: 2 ,color:'white'}}>
                <CampaignIcon fontSize="large" /> Announcements
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9, mt: 1 }}>
                Manage and send updates to your students
              </Typography>
            </Box>

            {/* Filter Dropdown in Header */}
            <Box sx={{ minWidth: 250, background: 'rgba(255,255,255,0.15)', borderRadius: 2, padding: '4px 10px' }}>
               <TextField
                select
                fullWidth
                variant="standard"
                value={courseCode}
                onChange={handleSelectAnnoucementFilter}
                // Styling text to be white
                InputProps={{ 
                    disableUnderline: true, 
                    style: { color: 'white', fontWeight: 500 } 
                }}
                // Styling the Dropdown Icon and forcing Empty Display
                SelectProps={{
                    displayEmpty: true, // <--- THIS FIXES THE VISIBILITY ISSUE
                    iconComponent: () => <FilterAltIcon sx={{ color: 'white' }} />,
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                bgcolor: 'white', // Ensure dropdown list is white
                                color: 'black'
                            }
                        }
                    }
                }}
              >
                <MenuItem value="">
                    <em>All Courses</em>
                </MenuItem>
                {cmbCourses.map((course) => (
                  <MenuItem key={course.code} value={course.code}>
                    {course.title}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>
        </Fade>

        {/* 2. Toggle Compose Button */}
        <Box display="flex" justifyContent="flex-end" mb={2}>
            <Button
              variant="contained"
              onClick={toggleCompose}
              startIcon={isComposeVisible ? <CloseIcon /> : <AddIcon />}
              sx={{
                backgroundColor: isComposeVisible ? "#757575" : colors.primary,
                borderRadius: "30px",
                padding: "10px 24px",
                fontWeight: "bold",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                "&:hover": {
                  backgroundColor: isComposeVisible ? "#616161" : colors.dark,
                },
              }}
            >
              {isComposeVisible ? "Cancel" : "Create Announcement"}
            </Button>
        </Box>

        {/* 3. Compose Section (Collapsible) */}
        <Collapse in={isComposeVisible}>
          <Card style={styles.composeCard}>
            <CardContent sx={{ padding: "2rem" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Announcement Title"
                    variant="outlined"
                    value={announcementTitle}
                    onChange={(e) => setannouncementTitle(e.target.value)}
                    helperText={`${announcementTitle.length}/55 Characters`}
                    error={announcementTitle.length > 55}
                    sx={styles.inputField}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Select Course"
                    value={selectedCourse}
                    onChange={(e) => setselectedCourse(e.target.value)}
                    variant="outlined"
                    sx={styles.inputField}
                    // Ensure this dropdown also behaves correctly if empty
                    SelectProps={{
                        displayEmpty: true,
                    }}
                  >
                    <MenuItem value="" disabled>
                        <em>Select a Course</em>
                    </MenuItem>
                    {cmbCourses.map((course) => (
                      <MenuItem key={course.code} value={course.code}>
                        {course.title}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>

              <Typography variant="subtitle1" fontWeight="600" mb={1} color={colors.dark}>
                Message Content
              </Typography>
              <Box sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden", mb: 3 }}>
                <JoditEditor
                  value={AnnoucementDesc}
                  onBlur={(newContent) => setAnnoucementDesc(newContent)}
                  onChange={(newContent) => {}}
                />
              </Box>

              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  onClick={handleAddAnnouncement}
                  endIcon={<SendIcon />}
                  sx={{
                    bgcolor: colors.primary,
                    padding: "10px 30px",
                    fontWeight: "bold",
                    "&:hover": { bgcolor: colors.dark },
                  }}
                >
                  Send Announcement
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Collapse>

        {/* 4. Table Section */}
        <Fade in timeout={800}>
          <Card style={styles.tableCard}>
            <MaterialTable
              title={
                <Typography variant="h6" fontWeight="bold" color={colors.text}>
                  <CampaignIcon sx={{ verticalAlign: 'middle', mr: 1, color: colors.primary }} />
                  Sent Announcements
                </Typography>
              }
              columns={[
                { 
                    title: "Title", 
                    field: "tittle",
                    render: rowData => <span style={{ fontWeight: 600 }}>{rowData.tittle}</span>
                },
                {
                  title: "Content Preview",
                  field: "content",
                  render: (rowData) => {
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = rowData.content;
                    const text = tempDiv.textContent || tempDiv.innerText || "";
                    return text.length > 80 ? `${text.substring(0, 80)}...` : text;
                  },
                },
                { 
                    title: "Date Sent", 
                    field: "createdDate",
                    render: rowData => (
                        <Chip 
                            label={rowData.createdDate} 
                            size="small" 
                            sx={{ bgcolor: colors.bgGradientEnd, color: colors.dark, fontWeight: 'bold' }} 
                        />
                    )
                },
              ]}
              data={annoucements}
              options={{
                exportButton: true,
                headerStyle: {
                  backgroundColor: colors.primary,
                  color: "#FFF",
                  fontWeight: "bold",
                  fontSize: "1rem"
                },
                rowStyle: {
                    fontSize: "0.95rem"
                },
                searchFieldStyle: {
                    borderBottom: `2px solid ${colors.primary}`
                },
                actionsColumnIndex: -1,
                padding: "dense"
              }}
            />
          </Card>
        </Fade>

      </Container>
    </Box>
  );
};

// Helper for Chip inside table
const Chip = ({ label, sx, size }) => (
    <Box sx={{ 
        display: 'inline-block', 
        borderRadius: '16px', 
        px: 1.5, 
        py: 0.5, 
        fontSize: size === 'small' ? '0.75rem' : '1rem',
        ...sx 
    }}>
        {label}
    </Box>
);

export default Annoucements;

